<script lang="ts">
  import { useOrg } from '../../../shared/auth/org.svelte';
  import { fa } from '../../../shared/i18n/fa';
  import { TourOverlay, tour } from '../../../shared/tour';
  import { useCompleteWelcome } from '../api/welcome-api';
  import { pageSteps } from '../lib/tour';
  import { replay } from '../lib/replay.svelte';
  import WelcomeTour from './WelcomeTour.svelte';

  /**
   * Mounted by the org route. Opens the welcome by itself for a clinic member who has not seen it
   * (`onboardedAt` null); its last button hands over to the tour of the real pages, and the welcome
   * counts as done when that tour finishes or is skipped (or when the dialog itself is skipped), not
   * when the dialog hands over. «راهنمای شروع» runs the page tour directly and records nothing.
   * The server remembers a finished or skipped first time so it never opens by itself again.
   */
  const org = useOrg();
  const complete = useCompleteWelcome(() => org.orgId);
  let phase = $state<'dialog' | 'tour' | 'done'>('dialog');
  const isClinic = $derived(org.membership.organization.type === 'clinic');
  const forced = $derived(isClinic && org.membership.onboardedAt === null && phase === 'dialog');

  function startTour(firstTime: boolean) {
    const steps = pageSteps(org.can, fa.welcomeTour.steps);
    if (firstTime) phase = steps.length > 0 ? 'tour' : 'done';
    tour.start(steps, {
      orgId: org.orgId,
      onEnd: () => {
        if (!firstTime) return;
        phase = 'done';
        complete.mutate();
      },
    });
    if (firstTime && steps.length === 0) complete.mutate();
  }

  $effect(() => {
    if (!replay.requested) return;
    replay.close();
    if (isClinic && !tour.running && !forced) startTour(false);
  });
</script>

{#if forced}
  <WelcomeTour
    forced={true}
    onClose={() => {
      phase = 'done';
    }}
    onStartTour={() => startTour(true)}
  />
{/if}
<TourOverlay />
